module.exports = __webpack_public_path__ + "img/Mother,-calf-and-escort.7ca5c2a9.jpg";